import axios, { type InternalAxiosRequestConfig } from "axios";
import { acquireIdToken, notifyAuthRequired } from "../auth/acquireIdToken";

const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:3000";

type RequestConfigWithAuthRetry = InternalAxiosRequestConfig & { _authRetry?: boolean };

export const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

// Elke request: geldig id-token uit de MSAL-cache (stil verversen als het bijna verlopen is).
api.interceptors.request.use(async (config) => {
  const { token } = await acquireIdToken({ allowInteractive: false });
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 401: één keer een vers token forceren. Lukt dat niet, dan aanmelden — geen verlopen reservekopie.
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const status = err.response?.status;
    const config = err.config as RequestConfigWithAuthRetry | undefined;
    if (status !== 401 || !config) {
      return Promise.reject(err);
    }
    if (config._authRetry) {
      notifyAuthRequired();
      return Promise.reject(err);
    }
    const { token, redirecting } = await acquireIdToken({
      forceRefresh: true,
      allowInteractive: true,
    });
    if (token) {
      config._authRetry = true;
      config.headers.Authorization = `Bearer ${token}`;
      return api.request(config);
    }
    if (!redirecting) {
      notifyAuthRequired();
    }
    return Promise.reject(err);
  }
);
